import { render, staticRenderFns } from "./preventiveXCorrective.vue?vue&type=template&id=677a20d2"
import script from "./preventiveXCorrective.vue?vue&type=script&lang=js"
export * from "./preventiveXCorrective.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports